import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'antd';
import styles from './App.module.less';

// 通过 fetch+blob 绕开 iOS Safari 对 Content-Type 的严格校验
const ImgLoader = ({ src, ...props }: any) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!src) return;
    let active = true;
    let objectUrl = '';

    fetch(src)
      .then((res) => res.blob())
      .then(async (blob) => {
        if (!active) return;
        const arr = new Uint8Array(await blob.slice(0, 4).arrayBuffer());
        let type = 'image/jpeg';
        if (arr[0] === 0x89 && arr[1] === 0x50) type = 'image/png';
        else if (arr[0] === 0x47 && arr[1] === 0x49) type = 'image/gif';
        else if (arr[0] === 0x52 && arr[1] === 0x49) type = 'image/webp';
        objectUrl = URL.createObjectURL(new Blob([blob], { type }));
        if (active) setUrl(objectUrl);
      })
      .catch((e) => console.error('Failed to load image', e));

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  return url ? <img src={url} {...props} /> : <div className={styles.imgPlaceholder} />;
};

const VideoPlayer = ({ src, ...props }: any) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    let active = true;
    let objectUrl = '';

    if (src) {
      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          if (!active) return;
          const videoBlob = new Blob([blob], { type: 'video/mp4' });
          objectUrl = URL.createObjectURL(videoBlob);
          setUrl(objectUrl);
        })
        .catch((e) => console.error('Failed to load video', e));
    }

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (!url) return null;

  return (
    <video
      src={url}
      // muted
      autoPlay
      controls
      playsInline
      {...props}
      controlsList='nodownload nofullscreen noplaybackrate'
      disablePictureInPicture
      disableRemotePlayback
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};

const items = [
  {
    thumbSrc: '/images/thumb-02.mp3',
  },
  {
    thumbSrc: '/images/thumb-01.mp3',
  },
  {
    thumbSrc: '/images/thumb-03.mp3',
  },
  {
    thumbSrc: '/images/thumb-04.mp3',
  },
  {
    thumbSrc: '/images/thumb-06-1.mp3',
  },
  {
    thumbSrc: '/images/thumb-05.mp3',
  },
];

const ImageGrid = () => {
  const ModalRef = useRef<any>();

  const [srcIdx, setSrcIdx] = useState(0);
  const [audio, setAudio] = useState(null);

  const handleClose = (event?: any) => {
    event?.stopPropagation();
    event?.preventDefault();

    audio?.pause?.();

    ModalRef.current?.destroy();
  };

  const handleClick = (item, event) => {
    const { thumbSrc, imgSrc, audioSrc } = item || {};

    event?.stopPropagation();
    event?.preventDefault();

    handleClose();

    if (Array.isArray(imgSrc) || Array.isArray(thumbSrc)) {
      setSrcIdx((prevIdx) => (prevIdx + 1) % imgSrc.length);
    }

    let displayImgSrc =
      (Array.isArray(imgSrc) ? imgSrc[srcIdx] : imgSrc) || (Array.isArray(thumbSrc) ? thumbSrc[srcIdx] : thumbSrc);

    // const displayImgSrc = Array.isArray(imgSrc)
    //   ? imgSrc[srcIdx]
    //   : imgSrc || thumbSrc;

    console.log(33333, srcIdx, displayImgSrc);

    ModalRef.current = Modal.info({
      icon: null,
      footer: null,
      closable: true,
      centered: true,
      maskClosable: true,
      content: displayImgSrc?.endsWith('.md') ? (
        <VideoPlayer src={displayImgSrc} className={styles.imgPreview} />
      ) : (
        <ImgLoader
          src={displayImgSrc}
          onClick={handleClose}
          onTouchEndCapture={handleClose}
          className={styles.imgPreview}
          onContextMenu={(e) => e.preventDefault()}
        />
      ),
      wrapClassName: styles.modalWrp,
    });

    let newAudio;

    if (Array.isArray(audioSrc)) {
      newAudio = new Audio(audioSrc[srcIdx % 2]);
    } else if (audioSrc) {
      newAudio = new Audio(audioSrc);
    }

    if (newAudio) {
      setAudio(newAudio);
      newAudio.play();
    }
  };

  useEffect(
    () => () => {
      audio?.pause?.();
    },
    [audio],
  );

  useEffect(
    () => () => {
      handleClose();
    },
    [],
  );

  return (
    <div className={styles.grid}>
      {items.map((item, index) => (
        <div key={index} className={styles.gridItem}>
          <ImgLoader
            src={Array.isArray(item.thumbSrc) ? item.thumbSrc[srcIdx] : item.thumbSrc}
            onClick={handleClick.bind(null, item)}
            onTouchEndCapture={handleClick.bind(null, item)}
            className={styles.thumbnail}
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;
